import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { EntityRef } from './EntityRef'
import { WellKnownProductAttributesDict } from './WellKnownProductAttributesDict'
import { EntityRefOfString } from './EntityRefOfString'
/**
* Class ProductListItemDto
*  Информация о продукте
*/
export class ProductListItemDto extends ActiveModel {

  /**
  * id
  * ИД продукта<br>  */
  @ActiveField()
  id?: number


/**
  * slug
  * <inheritdoc cref="P:Domain.Entities.Products.ProductChannel.Slug" />
  */
  @ActiveField()
  slug?: string


/**
  * metaTitle
  * SEO: заголовок страницы товара в канале (meta title). <br><br>Если не задан — витрина генерирует его из данных товара<br>
  */
  @ActiveField()
  metaTitle?: null | string


/**
  * metaDescription
  * SEO: описание страницы товара в канале (meta description). <br><br>Если не задано — витрина генерирует его из данных товара<br>
  */
  @ActiveField()
  metaDescription?: null | string


/**
  * ogImageId
  * SEO: og-картинка страницы товара в канале (Domain.Entities.Resources.Resource.Id). <br><br>Если не задана — витрина берёт первое изображение товара<br>
  */
  @ActiveField()
  ogImageId?: null | string


  /**
  * allAttributes
  * Значения атрибутов, где: <br><br>ключ: идентификатор атрибута; <br><br>значение: значения атрибута<br>  */
  @ActiveField(() => undefined)
  allAttributes?: Record<string, array>


/**
  * keyAttributesIds
  * Идентификаторы ключевых атрибутов. <br><br>Возможна ситуация, когда идентификатор есть, а значений (Web.Api.Showcases.Controllers.Products.Models.ProductListItemDto.AllAttributes) для него нет<br>  */
  @ActiveField({
    setter(model: ProductListItemDto, prop: string, value: Array<number> | undefined, receiver?: ProductListItemDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => Number.parseInt(v)) : value,
        
        receiver)
    }
  })
  keyAttributesIds?: Array<number>


/**
  * @property categories
  * Категории продукта<br>  */
  @ActiveField({
    factory: [EntityRef, () => undefined]
  })
  categories?: Array<EntityRef>


  /**
  * wellKnownAttributes
  * Значения известных атрибутов, где: <br><br>ключ: системный идентификатор Web.Api.Showcases.Controllers.Attributes.Models.AttributeDto.SystemName; <br><br>значение: типизированное представление значений атрибута<br>  */
  @ActiveField({
    factory: [WellKnownProductAttributesDict, () => undefined]
  })
  wellKnownAttributes?: WellKnownProductAttributesDict


/**
  * @property images
  * Изображения продукта (упорядоченные)<br>  */
  @ActiveField({
    factory: [EntityRefOfString, () => undefined]
  })
  images?: Array<EntityRefOfString>


  /**
  * inStock
  * Кол-во товара на складе (именно эта SKU)<br>  */
  @ActiveField()
  inStock?: number


  /**
  * templateInStock
  * Если SKU относится к группе товаров, то имеется ли хоть что-то из группы на складе. <br><br>Честно вычисляется только если объект строится при запросе списка товаров, а<br>не, например, при запросе корзины/избранного, тогда всегда вычисляется от Web.Api.Showcases.Controllers.Products.Models.ProductListItemDto.InStock. <br><br>Также, если SKU не входит в группу товаров, то тоже вычисляется от Web.Api.Showcases.Controllers.Products.Models.ProductListItemDto.InStock  */
  @ActiveField()
  templateInStock?: boolean


  /**
  * isFavorite
  * Добавлен ли товар в избранное<br>  */
  @ActiveField()
  isFavorite?: boolean


/**
  * promoBadge
  * Бейдж акции (Domain.Entities.Promotions.Promotion.BadgeLabel).
  */
  @ActiveField()
  promoBadge?: null | string


  /**
  * promoPrice
  * Акционная цена для каталожных акций (ТЗ §4.4).  */
  @ActiveField()
  promoPrice?: null | number


/**
  * promoTerms
  * Условия акции для витрины (Domain.Entities.Promotions.Promotion.PublicTerms).
  */
  @ActiveField()
  promoTerms?: null | string


  /**
  * hasCartPromo
  * Есть корзинная акция без персональной цены в каталоге.  */
  @ActiveField()
  hasCartPromo?: boolean


  /**
  * hasCashbackPromo
  * Акция начисляет кэшбэк без снижения цены в каталоге.  */
  @ActiveField()
  hasCashbackPromo?: boolean
}
